import { attr, belongsTo, hasMany } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validateNumber,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type { Execution } from "parog-web/utils/dmp-parsing/abstract-dmp-parser";
import tWithDefault from "parog-web/utils/t-with-default";
import type CnamProcessStartedJournalEvent from "./cnam-process-started-journal-event";

//---- Automatically generated, don't update this part ----

export default class ReimbursementsRetrievedJournalEvent extends JournalEvent {
  static override type = "reimbursements-retrieved-journal-event";

  @attr("boolean", {
    allowNull: true
  })
  declare success: boolean;

  @attr("number") declare version: number;

  @belongsTo("cnam-process-started-journal-event", {
    async: false,
    inverse: "reimbursementsRetrievedJournalEvent"
  })
  declare cnamProcessStartedJournalEvent: CnamProcessStartedJournalEvent;

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.reimbursements-retrieved-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ],
      version: validateNumber({
        allowBlank: true,
        description: intl.t(
          "validations.reimbursements-retrieved-journal-event.version"
        )
      })
    };
  }

  //---- End of generated code ----

  static CURRENT_PARSING_VERSION = 1;

  @hasMany("refunded-journal-event", {
    async: true,
    polymorphic: true,
    inverse: "reimbursementsRetrievedJournalEvent"
  })
  actRefundedJournalEvents;

  @attr() declare structuredData: Record<string, Execution[]>;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "reimbursements-retrieved-journal-event": ReimbursementsRetrievedJournalEvent;
  }
}
